"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoadTypeLegend = RoadTypeLegend;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function RoadTypeLegend({
  entries
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, entries.map(({
    key,
    color,
    labelKey
  }) => /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1,
    key: key
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    borderRadius: 4,
    height: 8,
    sx: {
      backgroundColor: color
    },
    width: 8
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, t(labelKey)))));
}